// extracted by mini-css-extract-plugin
module.exports = {"root":"HeroThirdPartyBrand_root__B9kaP","logoContainer":"HeroThirdPartyBrand_logoContainer__a4Z7U"};